import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { useUploadImage } from "arkh";
import { useTodoCreateAddImageMutation } from "./__generated__/useTodoCreateAddImageMutation.graphql";

export function useTodoCreateAddImage(
  onCompleted: (id: string, uri: string) => void
) {
  const [generateImageLink] = useMutation<useTodoCreateAddImageMutation>(
    graphql`
      mutation useTodoCreateAddImageMutation {
        uploadImageLink {
          image {
            id
          }
          url
        }
      }
    `
  );

  const { uploadImage, prepareForImageUpload } = useUploadImage();

  return useCallback(
    async (
      imageURI: string,
      { width, height }: { width: number; height: number }
    ) => {
      const uploadIdRequest = prepareForImageUpload({
        width,
        height,
        localImageURI: imageURI,
      });
      generateImageLink({
        variables: {},
        onCompleted: (res) => {
          uploadIdRequest.then((uploadId) => {
            if (res.uploadImageLink) {
              onCompleted(res.uploadImageLink.image.id, imageURI);
              uploadImage({
                imageId: res.uploadImageLink.image.id,
                uploadURL: res.uploadImageLink.url,
                uploadId,
              });
            }
          });
        },
      });
    },
    [generateImageLink, onCompleted, prepareForImageUpload, uploadImage]
  );
}
